var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "copyBut",
    on: {
      "click": _vm.copy
    }
  }, [_c('fa', {
    attrs: {
      "icon": "copy"
    }
  }), _c('p', {
    staticClass: "text"
  }, [_vm._t("default")], 2), _c('input', {
    ref: "copytext",
    domProps: {
      "value": _vm.value
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }